import { Screen } from '~/screens/StressAssessments/[id]/reports';

export const StressAssessmentsReports: React.FC = () => {
  return <Screen />;
};
